import PropTypes from 'prop-types'

import { Box } from '@redriverpress/system'

export default function CollectionGridViewWrapper({ children }) {
  return (
    <Box
      display='grid'
      gridTemplateColumns={['1fr', null, '1fr 1fr']}
      gridGap={['0.5rem', null, '1rem']}
    >
      {children}
    </Box>
  )
}

CollectionGridViewWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}
